module.exports = __webpack_public_path__ + "static/media/edit_section_lock_sections.39c1cf87.mov";